export { DatosFacturacionCliente, validarDatosFacturacion } from "./datosfacturacioncliente";


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/index.tsx